<template lang="pug">
v-container.px-10(fluid)
  v-progress-linear(
    :active="loading",
    indeterminate,
    color="white",
    absolute,
    top
  )
  v-row.text-center(v-if="!entity")
    v-col.py-0
      h2.primary--text {{$t('Common.noEntitySelected')}}
      small.white--text {{$t('Common.selectEntityHelp')}}
  v-row(v-else)
    v-col.py-0
      v-card.px-10.py-5.my-5
        v-col.py-0.text-right
          v-btn(color="primary", @click="refresh") {{$t('Common.refresh')}}
            v-icon  mdi-refresh
        v-overlay(absolute, v-if="loading")
        g-data-table(
          dense,
          :headers="headers",
          :items="pagination.data",
          :options.sync="options",
          :server-items-length="pagination.total",
          v-bind="{ loading }",
        )
          template(v-slot:item.cancelScheduledAction="{ item }")
            app-entity-delete(:title="entityName", @confirm="remove(item)", v-if="ShowEntityDelete(entityName)")
              template(v-slot:btn="{ on }")
                v-icon(small, color="red", v-on="on") mdi-delete
          template(v-slot:top)
            app-entity-search(
              :criteria="$getInitialCriterias($route.params.criteria, pagination.where)",
              @pagination="pagination = $event",
              :loads="loads",
              :entity="entity",
            )
  v-row
    v-snackbar(v-model="snackbar")
      | {{ message }}
      v-btn(color="pink", text, @click="snackbar = false")
</template>

<style type="text/css">
.v-data-table td {
  white-space: nowrap;
}
.top-right {
  position: absolute;
  top: 1rem;
  right: .5rem;
}
</style>

<script>
import axios from 'axios';
import moment from 'moment-timezone';
import keys from 'lodash/keys';
import { AppEntityDelete } from '@@/components';
import IndexFilterMixin from '@/mixins/index-filter.mixin';

export default {
  components: {
    AppEntityDelete
  },
  name: 'scheduledActions-index',
  data: () => ({
    message: '',
    snackbar: false,
    loading: false,
    timer: null,
    wait: 500,
    pagination: {},
    options: {},
  }),
  mixins: [
    IndexFilterMixin,
  ],
  watch: {
    $route: {
      immediate: true,
      handler () {
        this.clear();
        this.load(this.options);
      }
    },
    options: {
      handler (options) {
        this.load(options)
      }
    }
  },

  computed: {
    loads() {
      return [
        "Trigger",
      ]
    },
    has () {
      return !!this.items.length
    },
    entityName () {
      return 'ScheduledAction'
    },
    entity () {
      return this.$searchEntity(this.entityName, 'name')
    },
    headers() {
      return ([
        { text: this.$t("ScheduledAction.action"), value: "cancelScheduledAction" },
        { text: this.$t("ScheduledAction.itemExternalId"), value: "itemExternalId" },
        { text: this.$t("ScheduledAction.entity"), value: "trigger.entity", "load": "Trigger"  },
        { text: this.$t("ScheduledAction.deletedAt"), value: "deletedAt", type: "DateTime" },
        { text: this.$t("ScheduledAction.createdAt"), value: "createdAt", type: "DateTime" },
        { text: this.$t("ScheduledAction.scheduledDatetime"), value: "scheduledDatetime", type: "DateTime" },
        { text: this.$t("ScheduledAction.executionDatetime"), value: "executionDatetime", type: "DateTime" },
        { text: this.$t("ScheduledAction.trigger"), value: "trigger.name", "load": "Trigger" },
        { text: this.$t("ScheduledAction.businessScope"), value: "businessScope.path", "load": "BusinessScope" },
      ]);
    },
  },
  methods: {
    ShowEntityDelete(name) {
      let entity = this.$store.state.schema.all.find(f => name == f.name)
      return entity.actions.delete;
    },
    async remove (entity) {
      this.loading = true;
      entity.entityState = ENV.ENTITY.STATE.DELETED;
      try {
        await axios.post('entity/graph', entity)
      } catch (e) {
        this.snackbar = true
        this.message = e.response && e.response.data.message
      }
      await this.refresh()
    },
    getPagination(options = null, where = null) {
      options = options || this.options
      if (!keys(options).length) return
      return {
        params: {
          page: options.page,
          pageSize: options.itemsPerPage,
          orderBy: options.sortBy[0],
          desc: options.sortDesc[0],
          where: where,
          load: this.loads
        }
      }
    },
    /* TODO: docs */
    async load (options = null) {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        const pagination = this.getPagination(options, this.pagination.where)
        if (this.entity) {
          this.loading = true
          var criteria = this.$route.params.criteria ? { Where: [this.$route.params.criteria.value] } : null
          pagination.params = {...pagination.params, ...criteria}
          try {
            const envEndpoint = _.get(ENV.ENTITIES, this.entityName  + '.index.endpoint', this.entityName);
            const envParams = _.get(ENV.ENTITIES, this.entityName  + '.index.params', {});
            pagination.params = _.merge(pagination.params, envParams);
            const paginationresult = (await axios.get(this.$fetchLoad(envEndpoint, ...this.loads), pagination)).data;
            paginationresult.data = (paginationresult.data || []).map(d => ({
              // The date should be a UTC format, otherwise it's not going to work.
              ...d,
              createdAt: moment(d.createdAt).format('YYYY-MM-DD HH:mm'),
              deletedAt: d.deletedAt != null ? moment(d.deletedAt).format('YYYY-MM-DD HH:mm') : d.deletedAt,
              scheduledDatetime: moment(d.scheduledDatetime).format('YYYY-MM-DD HH:mm'),
              executionDatetime: d.executionDatetime != null ? moment(d.executionDatetime).format('YYYY-MM-DD HH:mm') : d.executionDatetime,
            }));
            this.pagination = paginationresult;
          } catch (err) {}
          this.loading = false
        }
      }, this.wait)
    },

    clear () {
      this.options = {
        ...this.options,
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      };
    },

    refresh () {
      this.clear();
      this.load();
    }
  },
}
</script>
